import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.starts-with.js";
var SIZE_2_GB = 2 * 1024 * 1024 * 1024;
export default function isScormOrMicrosite(_x) {
  return _isScormOrMicrosite.apply(this, arguments);
}
function _isScormOrMicrosite() {
  _isScormOrMicrosite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
    var _yield$import, jsZip, content, isMicrosite, isScorm, isValid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return import( /* webpackChunkName: "jszip" */'jszip');
        case 2:
          _yield$import = _context.sent;
          jsZip = _yield$import.default;
          _context.prev = 4;
          _context.next = 7;
          return jsZip.loadAsync(file);
        case 7:
          content = _context.sent;
          isMicrosite = Boolean(content.file(/^(\/?[^/]*\/?index\.html)$/).length);
          isScorm = Boolean(content.file('imsmanifest.xml'));
          isValid = Boolean(isMicrosite || isScorm);
          return _context.abrupt("return", {
            file: file,
            isValid: isValid,
            isScorm: isScorm,
            isMicrosite: isMicrosite
          });
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](4);
          if (!(_context.t0 instanceof DOMException && _context.t0.message.startsWith('The requested file could not be read') && file.size > SIZE_2_GB)) {
            _context.next = 18;
            break;
          }
          return _context.abrupt("return", {
            file: file,
            isValid: null
          });
        case 18:
          return _context.abrupt("return", {
            file: file,
            isValid: false
          });
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 14]]);
  }));
  return _isScormOrMicrosite.apply(this, arguments);
}